import { Component, inject } from '@angular/core';
import { AuthService } from '@cfp/core';
import { LoadingSpinner } from '@cfp/ui/common';

@Component({
  templateUrl: './logout.page.html',
  imports: [LoadingSpinner]
})
export class LogoutPage {
  private readonly authService = inject(AuthService);

  protected loading: boolean = true;

  constructor() {
    this.authService.logoutServerSideAndRedirect();
  }
}
